import { defineChannel, type ChannelDefinition } from '../channel-definition';

export const slackChannel = defineChannel({
  id: 'slack',
  icon: 'slack',
  name: 'Slack message',
  shortName: 'Slack message',
  noun: 'Slack message',
  events: ['attempted', 'sent', 'deferred', 'failed', 'converted', 'drafted', 'undeliverable'],
  deliveryStates: ['attempted', 'sent', 'failed', 'holdout'],
  deliveryActions: ['clicked'],
} as const satisfies ChannelDefinition);
